module.exports = __webpack_public_path__ + "static/media/ndf_mobile.30b5cc33.png";